import type { RouteRecordRaw } from 'vue-router';

export const pipelineRoutes: Array<RouteRecordRaw> = [
  {
    path: 'meus-negocios',
    props: true,
    name: 'Deals',
    component: () => import('@/views/private/pipeline/PipelineDealsView.vue'),
    children: [
      {
        path: ':pipelineName',
        props: true,
        name: 'KanbanBoard',
        component: () =>
          import('@/modules/pipeline/components/PipelineDealsMainContainer.component.vue'),
      },
    ],
  },
];
